import { createWebHistory, createRouter} from 'vue-router'
import login from "./components/login-main"
import home from "./components/home-main"
import page_error from "./components/page-error"
import customer from "./components/customers/customers-main"
import product from "./components/products/products-main"
import sale from "./components/sales/sales-main"
import invoice from "./components/invoices/invoices-main"

const routes = [
    {
        path:"/",
        component: login
    },
    {
        path:"/home",
        component: home
    },
    {
        path:"/customer",
        component: customer
    },
    {
        path:"/product",
        component: product
    },
    {
        path:"/sale",
        component: sale
    },
    {
        path:"/invoice",
        component: invoice
    },
    {
        path:"/:catchAll(.*)",
        component: page_error
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;